import {ModalProps} from "react-bootstrap/Modal";
import {Button, Col, Dropdown, Form, FormSelect, Modal} from "react-bootstrap";
import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {actions, ICreateRename, IMove} from "../../store/sliceModal";
import {
    fetchCreateFolder,
    fetchFolders,
    fetchMoveFile,
    fetchMoveFileAll,
    fetchRenameFile
} from "../../fetch/FileRequest";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions as actionsFiles, IFolder} from "../../store/sliceFiles";
import SelectComponent from "../../component/SelectComponent/SelectComponent";


const ModalMove: FC<ModalProps & IMove> = (props) => {
    const {title, file, onHide, show, ids} = props
    const dispatch = useDispatch<AppDispatch>();

    const [folders, seFolders] = useState<IFolder[]>([])
    const [folder, seFolder] = useState<IFolder>({} as IFolder)
    useEffect(() => {
        if (file || ids?.length) {
            fetchFolders().then(resp => {
                if (resp.status === 200) {
                    resp.data.push({name: 'root', id: null, path: '\\'} as IFolder)
                    seFolders(resp.data)
                }
            })
        }
    }, [show])


    const click = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        if (file) {
            fetchMoveFile(file.id, folder.id, file.folder)
        }

        if (ids?.length) {
            fetchMoveFileAll(ids, folder.id).then(resp => {
                if (resp.status == 200) {
                    dispatch(actionsFiles.clearChecked())
                }
            })
        }

        if (onHide) {
            onHide()
        }
    }, [folder])


    return (
        <Modal
            {...props}
            size={"sm"}
               centered
        >
            <Modal.Header closeButton>
                {title}
            </Modal.Header>
            <Modal.Body>

                <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>

                    <p>Выберите папку для перемещения</p>
                    <SelectComponent options={folders} onSelect={(f) => seFolder(f)}/>

                    <Button style={{width: "100px"}} variant={"outline-primary"} onClick={click}>ОК</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default memo(ModalMove)
